module.exports = __webpack_public_path__ + "img/5.d4db2b26.jpg";